<template>
  <component
    :is="props.icon"
    class="flex-shrink-0"
    :class="classes"
    aria-hidden="true"
  />
</template>

<script setup>
import { computed } from 'vue'
import { colorClasses } from '../util/colorMap'
import { iconSizeClasses } from './common'

const props = defineProps({
  icon: [Function, Object, String],
  color: {
    type: String,
    default: 'text-gray-400',
  },
  size: {
    type: String,
    default: 'md',
  },
})

const classes = computed(() =>
  [colorClasses(props.color), iconSizeClasses(props.size)].join(' ')
)
</script>
